import { IClient } from "@edgetier/watchtower-types";
import { useCallback } from "react";
import { PageNames } from "types-for/routes";
import { useIsRouteEnabled } from "../use-is-route-enabled";
import { getRouteHandle } from "constants/routes";

/**
 * Custom hook for filtering navigation children based on route availability and client settings.
 * @returns {function} Filter function to determine visibility of navigation items.
 */
const useFilterNavigationChildren = () => {
    const isRouteEnabled = useIsRouteEnabled();
    return useCallback(
        (pageName: PageNames, client: IClient | undefined) => {
            const handle = getRouteHandle(pageName);
            if (handle !== null && typeof handle.enabled !== "undefined") {
                return isRouteEnabled(handle.enabled, client);
            }
            return true;
        },
        [isRouteEnabled]
    );
};

export default useFilterNavigationChildren;
